import { Pipe, PipeTransform, Inject } from '@angular/core';
import dayjs from 'dayjs';
import Holidays from 'date-holidays';
import moment from 'moment-business-days';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/en';
import 'dayjs/locale/vi';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

dayjs.extend(localizedFormat);

@Pipe({ name: 'rocketDeadlineDate' })
export class RocketDeadlineDatePipe implements PipeTransform {
  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}
  transform(value: any, businessAdd: number, ...args: any[]): string {
    const date = value !== '' ? dayjs(value) : dayjs();
    moment.updateLocale('kr', {
      holidays: [
        '2025-01-01',
        '2025-01-27',
        '2025-01-28',
        '2025-01-29',
        '2025-01-30',
        '2025-03-03',
        '2025-05-01',
        '2025-05-05',
        '2025-05-06',
        '2025-06-06',
        '2025-07-20',
        '2025-08-15',
        '2025-10-03',
        '2025-10-06',
        '2025-10-07',
        '2025-10-08',
        '2025-10-09',
        '2025-12-25',
      ],
      holidayFormat: 'YYYY-MM-DD',
    });
    moment.updateLocale('kr', {
      workingWeekdays: [1, 2, 3, 4, 5],
    });

    // const holidays = new Holidays('KR', null, null);
    // console.log(holidays.getHolidays(2022));

    const deadline = moment(date.format('YYYY-MM-DD'), 'YYYY-MM-DD').businessAdd(businessAdd);
    return deadline.locale(this.i18n.language).format(args[0]);
  }

  getNextBusinessDay(currentDay: any) {
    const searchLimit = 7;
    let loopIndex = 1;
    const holidays = new Holidays('KR', null, null);

    while (loopIndex < searchLimit) {
      currentDay = currentDay.add(1, 'day');

      if (currentDay.isBusinessDay()) break;
      if (!holidays.isHoliday(currentDay.format('YYYY-MM-DD'))) break;
      loopIndex += 1;
    }

    return currentDay;
  }
}
